import {DishDocker} from 'aaden-base-model'
import {defineStore} from "pinia";
import {ref} from "vue";
import {collection, deleteDoc, doc, getDoc, getDocs, setDoc,} from "firebase/firestore";
import {db, Remember} from "@/plugins/firebase";
import {GlobalConfig, isFastFoodMode} from "@/dataLayer/repository/GlobalSettingManager";
import {getTableName} from "@/dataLayer/service/api";
import {useUserStore} from "@/dataLayer/userStore";
import hillo from "hillo";

export default DishDocker.StandardDishesListFactory()

export function getCollectionRef() {
  const path = isFastFoodMode() ? Remember.sessionId : getTableName()
  return collection(db, cartFireStoreName, GlobalConfig.DeviceId.toString(), path)
}

const cartFireStoreName = "qr-cart"
export const useCartStore
  = defineStore('cart', () => {
  const userStore = useUserStore()


  async function syncDataUp(localList) {

    try {
      const document = doc(getCollectionRef(), userStore.currentUserUid ? userStore.currentUserUid : 'defaultUser')
      await setDoc(document, {localList: JSON.stringify(localList)})
    } catch (e) {
      console.log(e)
      try {
        await sendLogToLark(e)
      } catch (error) {
        console.log(error)
      }

    }
  }

  async function clearGlobalCart() {
    try {
      (await getDocs(getCollectionRef())).docs.forEach(it => deleteDoc(it.ref))
    } catch (e) {
      console.log(e)
    }
  }

  async function getStoredCart() {
    try {
      return await getDoc(doc(getCollectionRef(), userStore.currentUserUid)).then(it => JSON.parse(it.data()?.localList))
    } catch (e) {
      return []
    }
  }

  const localList = ref([])
  return {localList, syncDataUp, getStoredCart, clearGlobalCart}
})

export async function sendLogToLark (e) {
  return await hillo.jsonPost('https://cloud-v2.aaden.io/api/lark/message/log',{
    message: JSON.stringify(e),
    tag: GlobalConfig.DeviceId + 'qr',
    destination: 'techconsole'
  })
}
